import { useContext } from 'react';
import { ConfigContext } from '../providers/ConfigContext';
import useMakeApiRequest from '../utils/makeApiRequest';

const useMakeWalletRefund = () => {
	const { apiBase } = useContext(ConfigContext);
	const makeApiRequest = useMakeApiRequest('POST');

	const makeRefund = async (walletId: any, transactionId: any, body: any) => makeApiRequest(`${apiBase}/api/wallets/${walletId}/transactions/${transactionId}/refunds`, body);

	return [makeRefund];
};

export default useMakeWalletRefund;
